/**
 * Innovation Dashboard Page
 * Main page for innovation management and future planning
 */

import React from 'react';
import InnovationDashboard from '../../components/innovation/InnovationDashboard';

const InnovationDashboardPage = () => {
  return (
    <div>
      <InnovationDashboard />
    </div>
  );
};

export default InnovationDashboardPage;
